module.exports = __webpack_public_path__ + "static/media/docker.14d3907a.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/icons/docker.png
// module id = 90
// module chunks = 0